import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '@kanos/ui';
import { useQuery } from '@tanstack/react-query';
import { Info, TriangleAlert } from 'lucide-react';
import { api } from './api.js';
import { formatDateTime } from './texts.js';
/**
 * The Kanos team's notice to everyone (after Corly's maintenance banner), under the bar of
 * every app while it is in force. Decoration of a kind: if the question fails, nothing shows -
 * the app works on. Asked every few minutes, so a notice set now reaches open apps soon.
 */
export function MaintenanceBanner() {
    const state = useQuery({
        queryKey: ['maintenance'],
        queryFn: async () => {
            const { data } = await api.GET('/api/v1/maintenance');
            return data?.notice ?? null;
        },
        refetchInterval: 5 * 60_000,
        staleTime: 60_000,
    });
    const notice = state.data;
    if (!notice)
        return null;
    const warning = notice.tone === 'warning';
    const Icon = warning ? TriangleAlert : Info;
    return (_jsxs("div", { role: "status", "aria-label": "Hinweis des Kanos-Teams", className: cx('flex shrink-0 items-start gap-2 px-safe-4 py-2 text-sm sm:px-safe-6 lg:px-safe-8', warning ? 'bg-warning-bg text-warning-fg' : 'bg-info-bg text-info-fg'), children: [_jsx(Icon, { "aria-hidden": true, className: "mt-0.5 size-4 shrink-0" }), _jsxs("p", { className: "min-w-0", children: [_jsx("span", { className: "font-semibold", children: warning ? 'Störung oder Wartung: ' : 'Hinweis: ' }), notice.message, notice.endsAt && (_jsxs("span", { className: "text-current/80", children: [" \u2013 bis ", formatDateTime(notice.endsAt)] }))] })] }));
}
//# sourceMappingURL=maintenance-banner.js.map